import { baseUrl, isSignedIn, getHeaders } from "@services/AuthServices";
import { queryFilter } from "@src/filters/query-filter";

export async function GetEgars(tableFilters) {
    await isSignedIn();

    const query = queryFilter(tableFilters);
    const urlApi = `${baseUrl}/SILiAmb/egar${query}`;

    return axios.get(urlApi, getHeaders(true));
}

export async function GetEgarPreFilled() {
    await isSignedIn();

    const urlApi = `${baseUrl}/SILiAmb/egar/pre-filled-form`;

    return axios.get(urlApi, getHeaders(true));
}

export async function GetEstablishment(tableFilters) {
    await isSignedIn();

    const query = queryFilter(tableFilters);
    const urlApi = `${baseUrl}/SILiAmb/establishment${query}`;

    return axios.get(urlApi, getHeaders(true));
}

export async function GetProducerTypes() {
    await isSignedIn();

    const urlApi = `${baseUrl}/SILiAmb/producers-types`;

    return axios.get(urlApi, getHeaders(true));
}

export async function GetLerCode() {
    await isSignedIn();

    const urlApi = `${baseUrl}/SILiAmb/ler-codes`;

    return axios.get(urlApi, getHeaders(true));
}

export async function GetOperationCode(lerEgarId) {
    await isSignedIn();

    const query = queryFilter({ lerCodeId: lerEgarId });
    const urlApi = `${baseUrl}/SILiAmb/operation-codes${query}`;

    return axios.get(urlApi, getHeaders(true));
}

export async function GetActorsSenders() {
    await isSignedIn();

    const urlApi = `${baseUrl}/SILiAmb/actors-senders`;

    return axios.get(urlApi, getHeaders(true));
}

export async function GetActorsTypes() {
    await isSignedIn();

    const urlApi = `${baseUrl}/SILiAmb/e-gar/actors-types`;

    return axios.get(urlApi, getHeaders(true));
}

export async function PostOrderEgars(body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/SILiAmb/egar`;

    return axios.post(urlApi, body, getHeaders(true));
}

export async function CancelOrderEgars(egarId) {
    await isSignedIn();

    const urlApi = `${baseUrl}/SILiAmb/egar/${egarId}/cancel`;

    return axios.put(urlApi, {}, getHeaders(true));
}

export async function GetEgar(egarId) {
    await isSignedIn();

    const urlApi = `${baseUrl}/SILiAmb/egar/${egarId}`;

    return axios.get(urlApi, getHeaders(true));
}

export async function PostUpdadeEgar(egarId, body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/SILiAmb/egar/${egarId}`;

    return axios.put(urlApi, body, getHeaders(true));
}

export async function GetTransporterNif(nif) {
    await isSignedIn();

    const query = queryFilter({ nif });
    const urlApi = `${baseUrl}/SILiAmb/transporter${query}`;

    return axios.get(urlApi, getHeaders(true));
}

export async function GetIndicador(tableFilters) {
    await isSignedIn();

    const query = queryFilter(tableFilters);
    const urlApi = `${baseUrl}/SILiAmb/indicators${query}`;

    return axios.get(urlApi, getHeaders(true));
}

export async function GetMainRouter(hasAdmin) {
    await isSignedIn();

    const urlApi = `${baseUrl}/SILiAmb/egar/main-routes/${hasAdmin}`;

    return axios.get(urlApi, getHeaders(true));
}

export async function PostOrderEgarToRouter(routeId, body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/SILiAmb/route/${routeId}/egar`;

    return axios.post(urlApi, body, getHeaders(true));
}

export async function PostPrintEgarForm(body) {
    await isSignedIn();
    const urlApi = `${baseUrl}/SILiAmb/egar/download-form`;
    return axios.post(urlApi, body, {...getHeaders(true), responseType: 'blob'});
}
